<ng-container [ngSwitch]="data">
  <div *ngIf="data == '0'">Postback</div>
  <div *ngIf="data == '1'">iFrame pixel</div>
</ng-container>
